/**
 * @generated SignedSource<<a607424f4a961147936377b7a97c82dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ClaimPlayableGlobalPlaythroughPriceInput = {
  amount: number;
  virtualId: number;
};
export type WalletGamblerTabClaimPlayableGlobalPlaythroughPriceMutation$variables = {
  input: ClaimPlayableGlobalPlaythroughPriceInput;
};
export type WalletGamblerTabClaimPlayableGlobalPlaythroughPriceMutation$data = {
  readonly claimPlayableGlobalPlaythroughPrice: {
    readonly success: boolean;
  } | null;
};
export type WalletGamblerTabClaimPlayableGlobalPlaythroughPriceMutation = {
  variables: WalletGamblerTabClaimPlayableGlobalPlaythroughPriceMutation$variables;
  response: WalletGamblerTabClaimPlayableGlobalPlaythroughPriceMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ClaimPlayableGlobalPlaythroughPricePayload",
    "kind": "LinkedField",
    "name": "claimPlayableGlobalPlaythroughPrice",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WalletGamblerTabClaimPlayableGlobalPlaythroughPriceMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WalletGamblerTabClaimPlayableGlobalPlaythroughPriceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4acf68f685f90703ee0df281392671cc",
    "id": null,
    "metadata": {},
    "name": "WalletGamblerTabClaimPlayableGlobalPlaythroughPriceMutation",
    "operationKind": "mutation",
    "text": "mutation WalletGamblerTabClaimPlayableGlobalPlaythroughPriceMutation(\n  $input: ClaimPlayableGlobalPlaythroughPriceInput!\n) {\n  claimPlayableGlobalPlaythroughPrice(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "ef30812663eabbf2e675adf6256cd8a5";

export default node;
